export const normalizeBorrowPositionUsdValue = (value: string | undefined) => {
  const parsedValue = Number(value ?? 0)
  return Number.isFinite(parsedValue) ? parsedValue : 0
}
